export default "__VITE_ASSET__BKreiHEt__"